/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_4_HInputs */

const en_terms_4_h = /** @type {(inputs: Terms_4_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans, payment and refunds`)
};

const id_terms_4_h = /** @type {(inputs: Terms_4_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket, pembayaran, dan pengembalian dana`)
};

/**
* | output |
* | --- |
* | "Plans, payment and refunds" |
*
* @param {Terms_4_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_4_h = /** @type {((inputs?: Terms_4_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_4_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_4_h(inputs)
	return en_terms_4_h(inputs)
});